import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSiteConfig } from "../config/SiteConfigContext";
import { pathFor } from "../app/paths";

/**
 * Informativa privacy GDPR sotto i form (finalità A per i contatti, B/C per auth).
 *
 * Il testo legale sta nell'i18n (chiavi `contact.consent` / `auth.consent`); la sola
 * parola "informativa" / "information" / "Informationen" è marcata `<link>…</link>`
 * nella stringa di traduzione e resa qui come <a> REALE via <Trans> — nessun
 * dangerouslySetInnerHTML. Il link apre la pagina Privacy Policy interna del progetto
 * (/{locale}/privacy) nella lingua corrente, in una nuova scheda.
 */
export function PrivacyNotice({
  variant,
  style,
}: {
  variant: "contact" | "auth";
  style?: React.CSSProperties;
}) {
  const { locale } = useParams();
  const cfg = useSiteConfig();
  const privacyUrl = pathFor("privacy", locale);
  return (
    <p style={{ fontSize: 12, color: "rgba(28,75,59,0.65)", lineHeight: 1.6, margin: 0, ...style }}>
      <Trans
        i18nKey={variant === "contact" ? "contact.consent" : "auth.consent"}
        components={{
          link: (
            <a
              href={privacyUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: cfg.color_dark, textDecoration: "underline", fontWeight: 600 }}
            />
          ),
        }}
      />
    </p>
  );
}
